import {
  Navigation,
  LandingBase,
  Hero,
  Automation,
  KeyFeatures,
  WhyChoose,
  Implementing,
  Reviews,
  FAQ,
  FinalCTA,
} from './LandingComponents';

export const Landing = () => {
  return (
    <>
      <Navigation />
      <LandingBase>
        <Hero />
        <Automation />
        <KeyFeatures />
        <WhyChoose />
        <Implementing />
        <Reviews />
        <FAQ />
        <FinalCTA />
      </LandingBase>
    </>
  );
};
